import { combineReducers } from 'redux';

import consultaCnhDefinitiva from './consultaCnhDefinitiva/reducer';

export default combineReducers({
	consultaCnhDefinitiva,
});
